export const environment = {
    production: false,
    appVersion: '1.0.0',
    versionCheckEnabled: false,
    baseurl: "https://app.complyb4.com/api/",
    storageBaseUrl: "https://cb4dev01storage01.blob.core.windows.net/pdfaccount1",
    appEnv: "development",
    bypassLogin: false,
    disableUpdatesToCompletedAssessments: false,
    bypassAssessmentSubmissionRequirements: true,
    appInsights: {
        instrumentationKey: "cde02b0a-7330-4b2a-a0c8-2aeae999d3e2",
        applicationId: "023b402f-bcec-4e08-ac82-9e8e49d0e3cb",
        connectionString:
            "InstrumentationKey=cde02b0a-7330-4b2a-a0c8-2aeae999d3e2;IngestionEndpoint=https://northeurope-2.in.applicationinsights.azure.com/;LiveEndpoint=https://northeurope.livediagnostics.monitor.azure.com/;ApplicationId=023b402f-bcec-4e08-ac82-9e8e49d0e3cb"
    }
};
